<template>
<div class="animated fadeIn">
  
  <App-SideMenu ></App-SideMenu>
    <main class="cd-main-content">
      <div class="landing-main-content">

      <div class="book-bg">
        <div class="pl-bg-gradientz">
          <div class="wrapper-square">
            <form class="login-form-wrapper">
              <div class="login-form-content">
                <h1>Sign In</h1>
                <!-- <div id="error-login-notify" class="animated pulse" v-if="loginErrorBox">{{loginErrorMessage}}</div> -->
                <div class="login-input-containers">
                  <!-- <float-label id="vfl-label"> -->
                    <h3 style="color:red;font-weight:bold;">EMAIL</h3>
                    <input v-model="username"  type="texts"  placeholder="Email">
                    
                  <!-- </float-label> -->
                  <label class="red fs-12 block">{{usernameErrorMessage}}</label>
                </div>
                  <div class="login-input-containers">
                    <!-- <float-label> -->
                      <h3 style="color:red;font-weight:bold;">PASSWORD</h3>
                      <input  v-model="password"  type="password" placeholder="Password">
                    <!-- </float-label> -->
                    <label class="red fs-12 block">{{passwordErrorMessage}}</label>
                  </div>
                  <!--<div id="login-fgtpass-link">
                    <a @click="handleRecovery()" class="pointer">Forgot your password?</a>
                  </div>-->
                  <br>
                    <a @click="handleSignIn()" class="pointer" id="login-register-btn">Sign In</a>
                  <div id="login-signup-link">
                  <h3>Use Serambi Ilmu Rakyat Account </h3>
                  <!--<h3>New to Serambi Ilmu Rakyat?
                    <a class="pointer" @click="handleRegister()">Sign up now.</a>
                  </h3>-->
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      </div>
    </main>
    
</div>
</template>

<script>
import _ from 'lodash'
import axios from "axios"
import db from '../components/firebase/firebaseinit'

export default {
  data()
  {
    return{
      alreadyCorrect : false,
      passwordWrong : false,
      existAlready : false,
      username : "",
      password : ""
    }
  },
  methods: {
    preventMobileScroll(event){
      if(this.hideScroll){
        event.preventDefault();
        event.stopPropagation();
      } else {
        event.unbind();
      }
    },
    
    onResize () {
              this.windowSize = { x: window.innerWidth, y: window.innerHeight }
              console.log('height:',this.windowSize.x,' width:',this.windowSize.y)
              this.changeSize()
          },
    changeSize(){
      if(this.windowSize.x<=800){
        this.resizeLogo = "padding:15px 0px 0 0px;height:48px;"
      }
    },

    getUsernameValidation: _.debounce(
    function () {
      var regexUser =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regexUser.test(this.username)) {
        this.usernameErrorMessage = "That email does not seem right."
        this.usernameError = true
        return
      }
      this.usernameError = false
      this.usernameErrorMessage = ''
      return true
    },
    // This is the number of milliseconds we wait for the
    // user to stop typing.
    500
    ),
    getPasswordValidation: _.debounce(
      function () {
        var regexPass = /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/;
        if (!regexPass.test(this.password)) {
          this.passwordErrorMessage = "Password should be at least 8 characters with alphabets and numerics."
          this.passwordError = true
          return
        }
        this.passwordError = false
        this.passwordErrorMessage = ''
        return true
      },
      // This is the number of milliseconds we wait for the
      // user to stop typing.
      500
    ),
    async getLoginValidation() {
      var bodyFormData = new FormData();
        bodyFormData.set('page', 'login');
        bodyFormData.set('Email', this.username);
        bodyFormData.set('Password', this.password);
        axios({
          method: 'post',
          url: "https://demolms.sage.com.my/sagelmsv4/mobile/mlogin.do",
          // url: "https://sir.celex.com.my/sir/mobile/mlogin.do",
          data: bodyFormData,
          config: {headers: {
            "Content-Type": "multipart/form-data"}
            }
        }) .then((response) => {
          if (response.data.status == "failed") {
            if(response.data.errorCode == 10) {
              this.$store.commit('setEmail', this.username);
              this.$router.push({
                name: 'activation'
              })
            } else if (response.data.errorCode == 9 || response.data.errorCode == 11) {
              this.loginErrorMessage = 'Sorry, we can`t find an account with this email address and password. Please try again.'
              this.password = ''
              this.passwordError = false
              this.passwordErrorMessage = ''
              this.loginErrorBox = false
              setTimeout(()=>{
                this.loginErrorBox = true
              }, 1)
            }
          } else if (response.data.errorCode == 15) {
              localStorage.setItem("token", response.data.token);
              this.$store.commit('setToken', response.data.token);
              this.$store.commit('setResponse', response.data);
              this.$router.push({
                  name: 'preference'
                })
          } else {
              localStorage.setItem("token", response.data.token);
              this.$store.commit('setToken', response.data.token);
              this.$store.commit('setResponse', response.data);
              this.$router.push({
                  name: 'landing'
                })
          }
        })
        .catch(function (response){
          this.$router.push({
            name: 'error'
          })
          console.log('catch',response)
        });
    },
    
    handleSignIn()
    {
      if(this.username == "" || this.password == "")
      {
        alert("Fill all information(s)")
      }

      else
      {
        db.collection('users').get().then(query =>
        {
          query.forEach(doc => 
          {
            if(this.username == doc.data().email) // correct email
            {
              this.existAlready = true
            }
          })

          if(!this.existAlready)
          {
            db.collection('users').add(
            {
              email: this.username,
              name: this.username,
              pwd: this.password,
              gender: "",
              location: "YBR_Test"
            })
          } 
          
          alert("Welcome To Serambi Ilmu Rakyat")
          this.$router.push({
            name: 'landing'
          })

          localStorage.setItem('session', (this.username))
        })

      }
      

      /*if(localStorage.getItem('session')===null)
      {
        alert("Email Are not Available")
      }

      /*
      for(var i = 0 ; i< this.user.length ; i++)
      {
          if(this.username == this.user[i].email && this.password == this.user[i].pwd) // check user
          {
            console.log('username:',this.username,' password:',this.password)
            
            localStorage.setItem('session', (this.user[i].email)); // get email, by real database, take id
            console.log(localStorage.getItem('session'));


          }
      }*/



    },
    
    handleRecovery() 
    {
      this.$router.push({
        name: 'recovery'
      })
    },

    handleRegister() 
    {
      this.$router.push({
        name: 'register'
      })
    },
  },
  mounted(){
    // this.periodicallyChangeLogo()
    this.onResize()
  },

}
</script>

<style lang="scss">
#side-menu{
  animation-duration: 0.5s;
  animation-delay: 0s;
}

.landing-color{
  background-color: #141414;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */

{
  opacity: 0
}

@media (max-width: 768px) {
  #swiper-option {
    display: none;
  }
}

.card-1:hover {
    -webkit-transition: all 0.3s cubic-bezier(.25,.8,.25,1);
   -moz-transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    -ms-transition: all 0.3s cubic-bezier(.25,.8,.25,1);
     -o-transition: all 0.3s cubic-bezier(.25,.8,.25,1);
        transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  -webkit-transform: scale(0.95);
   -moz-transform: scale(0.95);
    -ms-transform: scale(0.95);
     -o-transform: scale(0.95);
        transform: scale(0.95);
 -webkit-box-shadow: 0 1px 7px rgba(0,0,0,0.38), 0px 2px 9px rgba(0,0,0,0.38);
   -moz-box-shadow: 0 1px 7px rgba(0,0,0,0.38), 0px 2px 9px rgba(0,0,0,0.38);
        box-shadow: 0 1px 7px rgba(0,0,0,0.38), 0px 2px 9px rgba(0,0,0,0.38);
}

.landing-particles {
  position: fixed !important;
  width: 100vw;
}

.banner-bg {
  margin-top: 20px;
}

#mid-banner {
  width: 100%;
  text-align: center;
  #mid-banner-img {
    margin-top: 30px;
    width: 80%;
    max-width: 1400px;
  }
}

@media (max-width: 768px){
  #mid-banner {
    #mid-banner-img {
      width: 100%;
    }
  }

  .banner-bg, #mid-banner{
    padding: 0 10px;
  }
}

#landing-parallax {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative !important;
}

#stylo {
  position: relative !important;
}

.bws-tpc {
  #bws-items {
    display: inline-flex;
    margin-right: 2%;
    width: 23.25%;
    height: 100%;
    background-size: cover;
  }
  #bws-items:nth-child(4n) {
    margin-right: 0%;
  }
  #bws-items:hover {
    transition: all 0.5s cubic-bezier(0, 0, 0.25, 1);
    transform: scale(1.03);
  }
}

@media (max-width: 1200px) {
  .bws-tpc {
    #bws-items {
      margin-right: 2%;
      width: 48%;
      height: 100%;
      background-size: cover;
    }
    #bws-items:nth-child(2n) {
      margin-right: 0%;
    }
    #bws-items:nth-child(3n) {
      margin-top: 10px;
    }
    #bws-items:nth-child(4n) {
      margin-top: 10px;
    }
  }
}

.banner-swiper-container {
  // margin: 2% 0;
  #banner-swiper img {
    width: 100%;
    height: 100%;
    background-position: 50% 50%;
    background-size: cover;
  }
}

#tren-crs,
#bws-crs {
  width: 80%;
  margin: auto;
  margin-top: 0px;
  max-width: 1400px;
}

@media (max-width: 768px) {
  #tren-crs,
  #bws-crs {
    width: 100%;
    margin: auto;
    padding: 0 10px;
  }
}

#banner-pagination {
  text-align: center;
}

#banner-swiper:nth-child(n) {
  width: 80% !important;
}

#course-swiper:nth-child(n) {
  width: 16% !important;
}

#browse-swiper:nth-child(n) {
  width: 30% !important;
}

#subscribe-swiper:nth-child(n) {
  width: 30% !important;
}

#collection-swiper:nth-child(n) {
  width: 30% !important;
}

@media (min-width: 1201px) {
  #banner-swiper:nth-child(n) {
    width: 100% !important;
  }

  #course-swiper:nth-child(n) {
    width: 16% !important;
  }

  #browse-swiper:nth-child(n) {
    width: 35% !important;
  }

  #subscribe-swiper:nth-child(n) {
    width: 35% !important;
  }

  #collection-swiper:nth-child(n) {
    width: 35% !important;
  }
}

@media (max-width: 1200px) {
  #banner-swiper:nth-child(n) {
    width: 100% !important;
  }

  #course-swiper:nth-child(n) {
    width: 20% !important;
  }

  #browse-swiper:nth-child(n) {
    width: 45% !important;
  }

  #subscribe-swiper:nth-child(n) {
    width: 45% !important;
  }

  #collection-swiper:nth-child(n) {
    width: 45% !important;
  }
}

@media (max-width: 992px) {
  #banner-swiper:nth-child(n) {
    width: 100% !important;
  }

  #course-swiper:nth-child(n) {
    width: 25% !important;
  }

  #browse-swiper:nth-child(n) {
    width: 55% !important;
  }

  #subscribe-swiper:nth-child(n) {
    width: 55% !important;
  }

  #collection-swiper:nth-child(n) {
    width: 55% !important;
  }
}

@media (max-width: 768px) {
  #banner-swiper:nth-child(n) {
    width: 100% !important;
  }

  #course-swiper:nth-child(n) {
    width: 40% !important;
  }

  #browse-swiper:nth-child(n) {
    width: 70% !important;
  }

  #subscribe-swiper:nth-child(n) {
    width: 70% !important;
  }

  #collection-swiper:nth-child(n) {
    width: 70% !important;
  }
}

.browse-swiper-container {
  .swiper-lazy-preloader {
    background-position: center;
    margin-top: 15%;
  }
  img {
    width: 100%;
    height: 100%;
  }
}

.crs-swiper-container {
  .swiper-lazy-preloader {
    background-position: center;
    margin-top: 45%;
  }
  img {
    width: 100%;
    height: 100%;
  }
}

.subs-swiper-container {
  margin-bottom: 20px;
  .swiper-lazy-preloader {
    background-position: center;
    margin-top: 20%;
  }
  img {
    width: 100%;
    height: 100%;
  }
}

.coll-swiper-container {
  margin-bottom: 40px;  
  .swiper-lazy-preloader {
    background-position: center;
    margin-top: 38%;
  }
  img {
    width: 100%;
    height: 100%;
  }
}


/*
@media (max-width: 1200px) {
    .swiper-container {
        #course-swiper img {
          width: 100%;
          height: 100%;
          max-height:14vh;
          min-height: 14vh;
        }
    }
}
*/


/* --------------------------------

Primary style

-------------------------------- */


/*Make it scrolless and clean*/

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  &:after,
  &:before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
}


/*need to set this to assign to the main element a min height of 100%*/


/* --------------------------------

Modules - reusable parts of our design

-------------------------------- */


/*Main components */

input[type=texts], input[type=password] {
    width: 100%;
    padding: 12px 20px;
    margin: 8px 0;
    display: inline-block;
    border: 1px solid #ccc;
    box-sizing: border-box;
    color:black;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color:black ;
    opacity: 1; /* Firefox */
}
​

#landing-body {
  height: 100%;
  font-size: 100%;
  color: #fff;
  // overflow-y: visible;
}

.landing-main-content {
  /*Main Content including bg -color chg-*/
  /* set a min-height and a z-index to be sure that the main element completely covers the lateral menu */
  min-height: 100%;
  position: relative !important;
  z-index: 1;
  padding: 10px 10px 10px 10px;
  display: block;
  h3 {
    display: inline-block;
    font-weight: 500;
    font-size: 20px;
    /*was 20px*/
    letter-spacing: 1px;
    padding-bottom: 5px;
    margin-top: 30px;
    margin-bottom: 10px;
  }
  .landing-right-arrow {
    display: inline-block;
    text-decoration: none;
    font-size: 30px;
    font-weight: 800;
    color: #fff;
    margin: 10px 0 0 0;
  }
}

@media (max-width: 768px) {
  .cd-main-content {
    h3 {
      font-size: 20px;
    }
  }
}


/*.landing for side navi*/


/*give padding when switch to mobile*/

@media only screen and (max-width: 768px) {
  .landing-main-content {
    padding: 0px 0px 0px 0px;
  }
}

@media only screen and (max-width: 375px) {
  .landing-main-content h3 {
    font-size: 16px;
  }
}


/*Text style*/

#landing-top-nav a {
  display: inline-block;
  padding: 0.5em;
  color: #FFF;
  text-transform: uppercase;
  font-weight: 600;
  &.current {
    background-color: #242e30;
  }
}

.no-touch #landing-top-nav a:hover {
  color: rgba(255, 255, 255, 0.7);
}

@media only screen and (min-width: 768px) {
  #landing-top-nav {
    display: block;
  }
}


/*landing for menu btn*/


/*Side navi content style*/

#cd-navigation-home-icon {
  font-weight: 800;
}


/* style menu items which have a submenu The Arrow icon */

.owl-carousel {
  owl-theme .item img {
    width: 100%;
    height: 100%;
  }
  img {
    height: 100%;
  }
}

.main-content-header {
  margin: 0 auto 10px;
  h3 {
    display: inline-block;
  }
  a {
    display: inline-block;
    text-decoration: none;
    font-size: 30px;
    font-weight: 800;
    color: #000;
    margin: 10px 0 0;
  }
}
</style>


<style lang="scss">
#error-login-notify {
  margin: 1% 7%;
  background-color: #999;
  color: #fff;
  font-size: 18px;
  padding: 15px 10px;
}

@media (max-width: 768px) {
  #error-login-notify {
    font-size: 12px;
    padding: 10px 8px;
  }
}

.book-bg {
  background-image: url("/images/login-bg.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
}

@media (max-width: 768px) and (orientation: landscape) {
  .book-bg {
    height: 100vw;
  }
}

.pl-bg-gradientz {
  height: 100%;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.2));
}

.login-logo {
  img {
    display: block;
    width: 200px;
    min-width: 150px;
    padding-top: 2%;
    margin: 0 0 2% 2%;
  }
}

@media (max-width: 768px) and (orientation: portrait) {
  .login-logo {
    img {
      width: 150px;
      padding-top: 10%;
    }
  }
}

.login-form-wrapper {
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  max-width: 600px;
  min-width: 320px;
  min-height: 400px;
  max-height: 530px;
  color: #000;
  h1 {
    margin: 0 7%;
    padding-top: 40px;
    font-size: 48px;
    font-weight: 400;
  }
}

.login-form-content {
  background-color: #f3f3f3;
}

@media (max-width: 768px) {
  .login-form-wrapper {
    top: 100px;
    h1 {
      font-size: 36px;
    }
  }
  .login-input-containers label,
  #login-fgtpass-link {
    font-size: 12px;
  }
  #login-register-btn {
    font-size: 15px;
  }
  #login-signup-link h3 {
    font-size: 18px;
  }
}

//check this out
@media (max-width: 768px) and (orientation: landscape) {
  .login-form-wrapper {
    top: 300px;
  }
}

.login-input-containers {
  margin: 0 7% -5% ;
  
  font-size: 18px;
  input {
    height: 30px;
    min-height: 34px;
    color: #000;
    font-size: 100%;
    background-color: transparent;
    border-bottom: 2px solid #444;
    box-shadow: none;
  }
  .vfl-label {
    font-size: 18px;
    text-transform: uppercase;
  }
  .vfl-label-on-input {
    top: -1.5em;
  }
  .vfl-label-on-focus {
    color: #e50914;
  }
  .vfl-label-on-focus+input {
    border-bottom: 2px solid #e50914;
  }
}

@media (max-width:768px) {
  .login-input-containers {
    margin: 30px 7% 0;
    font-size: 16px;
    .vfl-label {
      font-size: 16px;
    }
    .vfl-label+input {
      font-size: 16px;
    }
  }
}

#login-fgtpass-link {
  color: #337ab7;
  margin: 30px 7% 0;
  display: block;
  text-decoration: none;
  font-size: 14px;
}

#login-fgtpass-link:hover {
  color: #1f799d;
}

#login-register-btn {
  color: #fff;
  background-color: #e50914;
  line-height: normal;
  margin: 15px 7% 0;
  padding: 2%;
  font-weight: 400;
  border-radius: 3px;
  font-size: 18px;
  text-decoration: none;
  display: block;
  text-align: center;
}

#login-register-btn:hover {
  background: #d9534f;
  background-image: -webkit-linear-gradient(top, #ff231f, #C20114);
  background-image: -moz-linear-gradient(top, #ff231f, #C20114);
  background-image: -ms-linear-gradient(top, #ff231f, #C20114);
  background-image: -o-linear-gradient(top, #ff231f, #C20114);
  background-image: linear-gradient(to bottom, #ff231f, #C20114);
  color: #ffffff;
  text-decoration: none;
}

#login-signup-link {
  h3 {
    margin: 15px 7% 0;
    font-size: 16px;
    padding-bottom: 40px;
  }
  a {
    color: #337ab7;
    text-decoration: none;
  }
  a:hover {
    color: #1f799d;
  }
}
</style>



// WEBPACK FOOTER //
// login.vue?4e0374cc